export default __webpack_public_path__ + "static/hcl_thumb-b5c66cc28ce9fb942d4cf9a03fc0ca6c.png";